import { store } from "../Redux";
import { callGetBetaFeatures } from "../Redux/slices/globalSlice";
import { BETA_PERMISSIONS } from "../data/constants";
import { getIsGuestUser, getPhoneNumberFromLs } from "../utils/commonUtils";

export function createAvailableFeaturesObj(allBetaFeatures: string[] = []) {
  let result: Record<string, boolean> = {};
  allBetaFeatures.forEach((feature: any) => {
    if (feature.availabilityType === BETA_PERMISSIONS.RESTRICTED || feature.availabilityType === BETA_PERMISSIONS.GA)
      result[feature.featureName] = true;
  })
  return result;
}

export function callBetaService(additionalPayload = {}) {
  let payload = {
    data: {
      msisdn: getPhoneNumberFromLs(),
      deviceName: "web",
      buildNumber: 1
    },
    ...additionalPayload
  }
  store.dispatch(callGetBetaFeatures(payload));
}

export function checkIsBetaFeatureAvailable(code: string = "") {
  if (getIsGuestUser()) return true;
  let betaFeatures = store.getState()?.globalStore?.availableBetaFeatures || {};
  return betaFeatures[code];
}